(function () {
  function initializeVideo(video) {
    if (video.dataset.haleDeferredVideoInitialized === 'true') return;

    video.dataset.haleDeferredVideoInitialized = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var banner = video.closest('.banner') || video.parentElement;
    var poster = banner && banner.querySelector('.js-deferred-hero-poster');
    var started = false;
    var listeners = [
      [window, 'scroll', { passive: true }],
      [window, 'wheel', { passive: true }],
      [document, 'mousemove', { passive: true }],
      [document, 'touchstart', { passive: true }],
      [document, 'pointerdown', { passive: true }],
      [document, 'keydown', false],
    ];

    function removeListeners() {
      listeners.forEach(function (listener) {
        listener[0].removeEventListener(listener[1], startVideo, listener[2]);
      });
    }

    function revealVideo() {
      if (poster) poster.hidden = true;
    }

    function playVideo() {
      try {
        video.currentTime = 0.1;
      } catch (error) {}

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function startVideo() {
      if (started) return;
      started = true;
      removeListeners();

      var viewport = window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
      var sources = Array.prototype.slice.call(video.querySelectorAll('source[data-src]'));
      var matchingSources = sources.filter(function (source) {
        return source.getAttribute('data-viewport') === viewport;
      });

      if (!matchingSources.length) matchingSources = sources.slice(0, 1);
      if (!matchingSources.length) return;

      matchingSources.forEach(function (source) {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
      });

      video.addEventListener('playing', revealVideo, { once: true });
      video.preload = 'auto';
      video.load();

      if (video.readyState >= 2) {
        playVideo();
      } else {
        video.addEventListener('loadeddata', playVideo, { once: true });
      }
    }

    listeners.forEach(function (listener) {
      listener[0].addEventListener(listener[1], startVideo, listener[2]);
    });
  }

  function initializeDeferredHeroVideos(root) {
    var videos = root.querySelectorAll('.js-deferred-hero-video');
    videos.forEach(initializeVideo);
  }

  initializeDeferredHeroVideos(document);

  if (!window.haleDeferredHeroSectionListenerAdded) {
    window.haleDeferredHeroSectionListenerAdded = true;
    document.addEventListener('shopify:section:load', function (event) {
      initializeDeferredHeroVideos(event.target);
    });
  }
})();
